let isDebug = false;
if (location['hostname'] === 'localhost' || location['hostname'] === '127.0.0.1' || location['hostname'] === 'marqponto-master-dev.azurewebsites.net') {
  isDebug = true
} else {
  isDebug = true
}
;
let utilService = {};
let vs1 = true;
if (vs1) {
  let _console = function (_0x25bfx5, _0x25bfx6) {
    if (isDebug) {
      console['log']('------------------------ Console --------------------------');
      console['log'](_0x25bfx5, _0x25bfx6);
      console['log']('-----------------------------------------------------------')
    }
  };
  let _showErrorsInDev = function (_0x25bfx8, _0x25bfx9, _0x25bfxa, _0x25bfxb) {
    if (isDebug) {
      console['log']('---------------------- Error ----------------------------');
      console['log']('URL: ', _0x25bfx8);
      console['log']('Value JSON: ', _0x25bfxb);
      console['log']('Erro: ', _0x25bfx9);
      console['log']('Status: ', _0x25bfxa);
      console['log']('---------------------------------------------------------')
    }
  };
  let _invalidToken = function (_0x25bfxa) {
    if (_0x25bfxa === 401) {
      localStorage['clear']();
      this['$router']['push']({
        path: '/login'
      })
    }
  };
  let _checkTheme = function () {
  };
  utilService['checkTheme'] = _checkTheme;
  utilService['console'] = _console;
  utilService['showErrorsInDev'] = _showErrorsInDev;
  utilService['invalidToken'] = _invalidToken
}
;
export const UTIL_SERVICE = utilService;
let requestServiceFactory = {};
let vs2 = true;
if (vs2) {
  axios['interceptors']['response']['use'](function (_0x25bfx11) {
    return _0x25bfx11
  }, function (_0x25bfx12) {
    if (_0x25bfx12['response'] && _0x25bfx12['response']['status'] === 401) {
      localStorage['clear']();
      this['$router']['push']({
        path: '/login'
      })
    }
    ;
    try {
      UTIL_SERVICE['showErrorsInDev'](_0x25bfx12['response']['request']['responseURL'], _0x25bfx12['response']['data'], _0x25bfx12['response']['status'], _0x25bfx12['response']['config']['data'])
    } catch (e) {
      console['log']('e', e)
    }
    ;
    return Promise['reject'](_0x25bfx12)
  });
  let HEADER = function () {
    let _0x25bfx14 = JSON['parse'](window['localStorage']['getItem']('marQAdminAuthUser'));
    let _0x25bfx15 = JSON['parse'](window['localStorage']['getItem']('mamUserMasterInfo'));
    let _0x25bfx16 = JSON['parse'](window['localStorage']['getItem']('browserId'));
    let _0x25bfx17 = {
      '\x43\x6F\x6E\x74\x65\x6E\x74\x2D\x54\x79\x70\x65': 'application/json',
      '\x41\x63\x63\x65\x70\x74': 'application/json'
    };
    if (_0x25bfx15) {
      if (_0x25bfx15['id'] && _0x25bfx15['companyId']) {
        _0x25bfx17['Up'] = _0x25bfx15['id'] + _0x25bfx15['companyId'];
        _0x25bfx17['uId'] = _0x25bfx15['id'];
        _0x25bfx17['cId'] = _0x25bfx15['companyId']
      }
    }
    ;
    if (_0x25bfx16) {
      _0x25bfx17['DeviceId'] = _0x25bfx16
    }
    ;
    if (_0x25bfx14) {
      if (_0x25bfx14['userToken'] && _0x25bfx14['isAuth']) {
        _0x25bfx17['Authorization'] = 'Bearer ' + _0x25bfx14['userToken']
      }
      ;
      if (_0x25bfx14['userContentSetting'] && _0x25bfx14['isAuth']) {
        _0x25bfx17['Contentsetting'] = _0x25bfx14['userContentSetting']
      }
    } else {
      console.log('NO TOKEN')
    }
    ;
    return _0x25bfx17
  };
  let _login = (_0x25bfx8, _0x25bfx19) => {
    let _0x25bfx1a = {
      headers: {
        '\x43\x6F\x6E\x74\x65\x6E\x74\x2D\x54\x79\x70\x65': 'application/x-www-form-urlencoded'
      }
    };
    return axios['post'](_0x25bfx8, qs['stringify']({
      password: _0x25bfx19['password'],
      username: _0x25bfx19['email'],
      grant_type: 'password',
      client_id: '099153c2625149bc8ecb3e85e03f0022'
    }), _0x25bfx1a)
  };
  let _fullAddress = (_0x25bfx1c) => {
    let _0x25bfx8 = 'https://ddd.pricez.com.br/cep/' + _0x25bfx1c + '.json';
    return axios['get'](_0x25bfx8)
  };
  let _get = (_0x25bfx8) => {
    return axios['get'](_0x25bfx8, {
      headers: HEADER()
    })
  };
  let _post = (_0x25bfx8, _0x25bfx19) => {
    return axios['post'](_0x25bfx8, _0x25bfx19, {
      headers: HEADER()
    })
  };
  let _put = (_0x25bfx8, _0x25bfx19) => {
    return axios['put'](_0x25bfx8, _0x25bfx19, {
      headers: HEADER()
    })
  };
  let _patch = (_0x25bfx8, _0x25bfx19) => {
    return axios['patch'](_0x25bfx8, _0x25bfx19, {
      headers: HEADER()
    })
  };
  let _delete = (_0x25bfx8) => {
    return axios['delete'](_0x25bfx8, {
      headers: HEADER()
    })
  };
  let _logout = () => {
    return new Promise(function (_0x25bfx23, _0x25bfx24) {
      try {
        window['localStorage']['removeItem']('marQAdminAuthUser');
        window['localStorage']['removeItem']('mamUserMasterInfo');
        _0x25bfx23('Success')
      } catch (err) {
        _0x25bfx24(err)
      }
    })
  };

  let _fileUpload = (_0x25bfx8, _0x25bfx26, context) => {
    let _0x25bfx27 = new FormData();
    let _0x25bfx28 = {
      headers: {
        '\x43\x6F\x6E\x74\x65\x6E\x74\x2D\x54\x79\x70\x65': undefined
      }
    };

    if (context)
      _0x25bfx28['contentSetting'] = context

    _0x25bfx27['append']('file', _0x25bfx26);
    return axios['post'](_0x25bfx8, _0x25bfx27, {
      headers: _0x25bfx28
    })
  };

  let _fileUploadV2 = (url, file, context, responseType) => {
    let formData = new FormData();
    let config = {
      headers: {
        'Content-Type': undefined
      }
    };

    if (context)
      config.headers['Contentsetting'] = context;

    let authUser = JSON.parse(window.localStorage.getItem('marQAdminAuthUser'));
    if (authUser.userToken && authUser.isAuth) {
      config.headers.Authorization = 'Bearer ' + authUser.userToken;
      config.Authorization = 'Bearer ' + authUser.userToken;
    }

    formData.append('file', file);
    return axios.post(url, formData, {
      headers: config.headers,
      // opcional: 'blob' para baixar o arquivo sem reinterpretar o encoding (ex.: CSV Windows-1252)
      responseType: responseType || 'json'
    });
  };

  let _getFile = (_0x25bfx8, _0x25bfx2a) => {
    let _0x25bfx2b = {
      method: 'GET',
      url: _0x25bfx8,
      params: {
        name: name
      },
      responseType: 'arraybuffer',
      headers: {
        '\x43\x6F\x6E\x74\x65\x6E\x74\x2D\x54\x79\x70\x65': 'application/json',
        '\x41\x63\x63\x65\x70\x74': 'application/json'
      }
    };
    if (_0x25bfx2a) {
      let _0x25bfx14 = JSON['parse'](window['localStorage']['getItem']('marQAdminAuthUser'));
      if (_0x25bfx14['userToken'] && _0x25bfx14['isAuth']) {
        _0x25bfx2b['headers']['Authorization'] = 'Bearer ' + _0x25bfx14['userToken']
      }
    }
    ;
    return axios(_0x25bfx2b)
  };
  let _customRequest = (_0x25bfx2d, _0x25bfx8, _0x25bfx19, _0x25bfx2e) => {
    let _0x25bfx2b = {
      method: _0x25bfx2d,
      url: _0x25bfx8,
      header: _0x25bfx2e
    };
    if (_0x25bfx2d === 'GET') {
      return axios['get'](_0x25bfx8, {
        headers: _0x25bfx2e
      })
    } else {
      if (_0x25bfx19) {
        _0x25bfx2b['data'] = _0x25bfx19
      }
      ;
      return axios(_0x25bfx2b)
    }
  };
  let _requestContext = (_0x25bfx2d, _0x25bfx8, _0x25bfx30, _0x25bfx19, isMultipart) => {
    let _0x25bfx31 = HEADER();
    if (_0x25bfx30) {
      _0x25bfx31['Contentsetting'] = _0x25bfx30;
    }
    ;
    // Para upload multipart (FormData), o Content-Type precisa ser undefined
    // para o axios gerar o boundary automaticamente. HEADER() força
    // application/json, o que quebra o multipart (sem boundary => o servidor
    // rejeita com 415). Mantemos o Contentsetting (shard) e o Authorization.
    if (isMultipart) {
      _0x25bfx31['Content-Type'] = undefined;
    }
    ;
    switch (_0x25bfx2d) {
      case 'GET':
        return axios['get'](_0x25bfx8, {
          headers: _0x25bfx31
        });
        break;
      case 'POST':
        return axios['post'](_0x25bfx8, _0x25bfx19, {
          headers: _0x25bfx31
        });
        break;
      case 'PUT':
        return axios['put'](_0x25bfx8, _0x25bfx19, {
          headers: _0x25bfx31
        });
        break;
      case 'DELETE':
        return axios['delete'](_0x25bfx8, {
          headers: _0x25bfx31
        });
        break
    }
  };
  
  requestServiceFactory['login'] = _login;
  requestServiceFactory['logout'] = _logout;
  requestServiceFactory['get'] = _get;
  requestServiceFactory['post'] = _post;
  requestServiceFactory['put'] = _put;
  requestServiceFactory['patch'] = _patch;
  requestServiceFactory['delete'] = _delete;
  requestServiceFactory['fileUpload'] = _fileUpload;
  requestServiceFactory['fileUploadV2'] = _fileUploadV2;
  requestServiceFactory['getFile'] = _getFile;
  requestServiceFactory['customRequest'] = _customRequest;
  requestServiceFactory['requestContext'] = _requestContext;
  requestServiceFactory['fullAddress'] = _fullAddress
}
;
export const REQUEST_SERVICE = requestServiceFactory;
let qs = require('qs');
import axios from 'axios';



// WEBPACK FOOTER //
// ./src/requestConfig.js